<template>
  <div class="vacancies">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="d-flex justify-content-between">
              <div class="col">
                <h3 class="page-title">Vacancies</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item active">Vacancies</li>
                  <li class="breadcrumb-item active" v-if="display === 'all'">
                    All
                  </li>
                  <li
                    class="breadcrumb-item active"
                    v-else-if="display === 'active'"
                  >
                    Active
                  </li>
                  <li
                    class="breadcrumb-item active"
                    v-else-if="display === 'inactive'"
                  >
                    Inactive
                  </li>
                </ul>
              </div>
              <div class="col-md-3 float-right ml-auto">
                <div class="row">
                  <button
                    class="btn btn-primary dropdown-toggle m-1"
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Status
                  </button>
                  <div
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <a class="dropdown-item" @click="getAllVacancies"
                      >All Vacancies</a
                    >
                    <a class="dropdown-item" @click="getActiveVacancies"
                      >Active Vacancies</a
                    >
                    <a class="dropdown-item" @click="getInactiveVacancies"
                      >Inactive Vacancies</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <div class="row">
            <div class="col-md-12">
              <div class="card">
                <div class="card-header">
                  <div class="d-flex justify-content-between">
                    <h4 class="card-title mb-0">Vacancies Information</h4>
                    <div class="col-auto float-right ml-auto">
                      <router-link to="/addvacancy" class="btn add-btn"
                        ><i class="fa fa-plus"></i>Add Vacancy</router-link
                      >
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <v-data-table
                      :headers="headers"
                      :items="vacancies"
                      sort-by=""
                      class="elevation-1"
                    >
                      <template v-slot:[`item.stat`]="{ item }">
                        <a
                          class="btn btn-white btn-sm btn-rounded"
                          v-if="item.status == 1"
                          aria-expanded="false"
                        >
                          <i class="fa fa-dot-circle-o text-purple"></i> New
                        </a>
                        <a
                          class="btn btn-white btn-sm btn-rounded"
                          v-if="item.status == 0"
                          aria-expanded="false"
                        >
                          <i class="fa fa-dot-circle-o text-success"></i> Active
                        </a>
                        <a
                          class="btn btn-white btn-sm btn-rounded"
                          v-if="item.status == 8"
                          aria-expanded="false"
                        >
                          <i class="fa fa-dot-circle-o text-danger"></i>
                          Inactive
                        </a>
                      </template>
                      <template v-slot:[`item.actions`]="{ item }">
                        <div class="dropdown dropdown-action">
                          <a
                            href="#"
                            class="action-icon dropdown-toggle"
                            data-toggle="dropdown"
                            aria-expanded="false"
                            ><i class="material-icons">more_vert</i></a
                          >
                          <div class="dropdown-menu dropdown-menu-right">
                            <router-link
                              :to="{
                                name: 'vacancydetail',
                                params: { id: item.id }
                              }"
                              class="dropdown-item"
                              ><i class="fa fa-pencil m-r-5"></i>
                              Edit</router-link
                            >
                            <a
                              class="dropdown-item"
                              @click="setCloseVacancy(item)"
                              ><i class="fa fa-trash-o m-r-5"></i> Close</a
                            >
                            <a
                              class="dropdown-item"
                              @click="setDeleteVacancy(item.id)"
                              ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                            >
                          </div>
                        </div>
                      </template>
                    </v-data-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Content -->
        </div>
        <v-dialog v-model="dialog" max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <h3>Close Vacancy</h3>
                <p>Are you sure want to close this vacancy?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      @click.prevent="closeVacancy"
                      class="btn btn-primary continue-btn"
                      :disabled="loading"
                      >{{ !loading ? 'Close' : 'Please wait' }}</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      @click="() => (dialog = false)"
                      class="btn btn-primary cancel-btn"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <v-dialog v-model="deleteDialog" max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <h3>Delete Vacancy</h3>
                <p>Are you sure want to delete this vacancy from record?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      @click.prevent="deleteVacancy"
                      class="btn btn-primary continue-btn"
                      :disabled="loading"
                      >{{ !loading ? 'Delete' : 'Please wait' }}</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      @click="closeDialogDelete"
                      class="btn btn-primary cancel-btn"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { authenticationService } from "@/services/authenticationService";
import { jobService } from "@/services/jobService";
import Vue from "vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar
  },
  data() {
    return {
      dialog: false,
      headers: [
        {
          text: "Name",
          align: "start",
          value: "title"
        },
        { text: "Employed Application", value: "acceptedApplicationCount" },
        { text: "Rejected Application", value: "rejectedApplicationCount" },
        { text: "New Application", value: "newApplicationCount" },
        { text: "Test", value: "aptitudeTestInterviewCount" },
        { text: "Interview", value: "interviewCount" },
        { text: "Status", value: "stat" },
        { text: "Action", value: "actions", sortable: false }
      ],
      vacancies: [],
      activevacancy: {},
      display: "all",
      activevacancies: [],
      inactivevacancies: [],
      loading: false,
      currentVacancyId: null,
      deleteDialog: false,
      currentOffice: authenticationService.currentOfficeValue
    };
  },
  mounted() {
    this.getAllVacancies();
    if ($(".datatable").length > 0) {
      $(".datatable").DataTable({
        bFilter: false
      });
    }
  },
  methods: {
    setCloseVacancy(model) {
      (this.dialog = true), (this.activevacancy = model);
    },
    setDeleteVacancy(id) {
      this.deleteDialog = true
      this.currentVacancyId = id
    },
    closeDialogDelete() {
      this.deleteDialog = false;
    },
    closeDelete() {
      this.dialog = false;
    },
    closeVacancy() {
      this.activevacancy.status = 8;
      this.loading = true
      jobService.updateVacancy(this.activevacancy).then(
        a => {
          alert('Vacancy closed successfully')
          jobService.getVacancySummaries(this.currentOffice.id).then(p => {
            this.vacancies = p;
            this.loading = false
            this.closeDelete();
          });
        },
        error => {
          this.error = error;
          alert(error)
          this.loading = false
        }
      );
    },
    deleteVacancy() {
      const id = this.currentVacancyId
      this.loading = true
      jobService.deleteVacancy(id).then(
        a => {
          alert('Vacancy deleted successfully')
          jobService.getVacancySummaries(this.currentOffice.id).then(p => {
            this.vacancies = p;
            this.loading = false
            this.closeDialogDelete();
          });
        },
        error => {
          this.error = error;
          alert(error)
          this.loading = false
        }
      );
    },
    getAllVacancies() {
      jobService.getVacancySummaries(this.currentOffice.id).then(p => {
        this.vacancies = p;
        this.display = "all";
      });
    },
    getActiveVacancies() {
      jobService.getVacancySummaries(this.currentOffice.id).then(p => {
        this.activevacancies = p.filter(a => a.status === 0);
        // console.log(this.activeapplications)
        this.vacancies = this.activevacancies;
        this.display = "active";
      });
    },
    getInactiveVacancies() {
      jobService.getVacancySummaries(this.currentOffice.id).then(p => {
        this.inactivevacancies = p.filter(a => a.status === 8);
        // console.log(this.inactiveapplications)
        this.vacancies = this.inactivevacancies;
        this.display = "inactive";
      });
    }
  },
  name: "vacancies"
};
</script>
<style scoped>
.datatable > thead > tr > th,
.datatable > tbody > tr > td {
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/vacancies/main.vue